// extracted by mini-css-extract-plugin
module.exports = {"loadingSkeleton":"index-module_loadingSkeleton_Fq776","loading":"index-module_loading_sPnOC"};